export const FOOTER_LINKS_QUERY_KEY = "footer::links"
